import React from 'react';
import { styled } from 'styled-components';

import BlueSpinner from 'Common/components/BlueSpinner';

const SubmittingOverlay = ({ show }: { show: boolean }) => {
  return <Overlay $show={show} data-testid="submitting-overlay">
    <BlueSpinner/>
  </Overlay>;
};

const Overlay = styled.div<{ $show: boolean }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: ${({$show}) => $show ? 'flex' : 'none'};
  align-items: center;
  justify-content: space-around;
  background-color: #00000020;
  z-index: 100;
`;

export default SubmittingOverlay;
